import { Toolbar, Theme } from '@mui/material';

import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';

export const DeloitteToolbar = withStyles((theme: Theme) =>
    createStyles({
        root: {
            minHeight: theme.deloitte.menuSize,
            alignItems: 'center',
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(0),
        }
    })
)((props) => <Toolbar disableGutters {...props} />);